export default function (nickName) {
  let emojiMap = {
    '': '👦',
    '': '👧',
    '': '💋',
    '': '👨',
    '': '👩',
    '': '👕',
    '': '👟',
    '': '📷',
    '': '📞',
    '': '📱',
    '': '📠',
    '': '💻',
    '': '👊',
    '': '👍',
    '': '☝',
    '': '✊',
    '': '✌',
    '': '✋',
    '': '🎿',
    '': '⛳',
    '': '🎾',
    '': '⚾',
    '': '🏄',
    '': '⚽',
    '': '🐟',
    '': '🐴',
    '': '🚗',
    '': '⛵',
    '': '✈',
    '': '🚃',
    '': '🚅',
    '': '❓',
    '': '❗',
    '': '❤',
    '': '💔',
    '': '🕐',
    '': '🕑',
    '': '🕒',
    '': '🕓',
    '': '🕔',
    '': '🕕',
    '': '🕖',
    '': '🕗',
    '': '🕘',
    '': '🕙',
    '': '🕚',
    '': '🕛',
    '': '🌸',
    '': '🔱',
    '': '🌹',
    '': '🎄',
    '': '💍',
    '': '💎',
    '': '🏠',
    '': '⛪',
    '': '🏢',
    '': '🚉',
    '': '⛽',
    '': '🗻',
    '': '🎤',
    '': '🎥',
    '': '🎵',
    '': '🔑',
    '': '🎷',
    '': '🎸',
    '': '🎺',
    '': '🍴',
    '': '🍸',
    '': '☕',
    '': '🍰',
    '': '🍺',
    '': '⛄',
    '': '☁',
    '': '☀',
    '': '☔',
    '': '🌙',
    '': '🌄',
    '': '👼',
    '': '🐱',
    '': '🐯',
    '': '🐻',
    '': '🐶',
    '': '🐭',
    '': '🐳',
    '': '🐧',
    '': '😊',
    '': '😃',
    '': '😞',
    '': '😠',
    '': '💩',
    '': '📫',
    '': '📮',
    '': '📩',
    '': '📲',
    '': '😜',
    '': '😍',
    '': '😱',
    '': '😓',
    '': '🐵',
    '': '🐙',
    '': '🐷',
    '': '👽',
    '': '🚀',
    '': '👑',
    '': '💡',
    '': '🍀',
    '': '💏',
    '': '🎁',
    '': '🔫',
    '': '🔍',
    '': '🏃',
    '': '🔨',
    '': '🎆',
    '': '🍁',
    '': '🍂',
    '': '👿',
    '': '👻',
    '': '💀',
    '': '🔥',
    '': '💼',
    '': '💺',
    '': '🍔',
    '': '⛲',
    '': '⛺',
    '': '♨',
    '': '🎡',
    '': '🎫',
    '': '💿',
    '': '📀',
    '': '📻',
    '': '📼',
    '': '📺',
    '': '👾',
    '': '〽',
    '': '🀄',
    '': '🆚',
    '': '💰',
    '': '🎯',
    '': '🏆',
    '': '🏁',
    '': '🎰',
    '': '🐎',
    '': '🚤',
    '': '🚲',
    '': '🚧',
    '': '🚹',
    '': '🚺',
    '': '🚼',
    '': '💉',
    '': '💤',
    '': '⚡',
    '': '👠',
    '': '🛀',
    '': '🚽',
    '': '🔊',
    '': '📢',
    '': '🎌',
    '': '🔒',
    '': '🔓',
    '': '🌆',
    '': '🍳',
    '': '📘',
    '': '💱',
    '': '💹',
    '': '📡',
    '': '💪',
    '': '🏦',
    '': '🚥',
    '': '🅿',
    '': '🚏',
    '': '🚻',
    '': '👮',
    '': '🏣',
    '': '🏧',
    '': '🏥',
    '': '🏪',
    '': '🏫',
    '': '🏨',
    '': '🚌',
    '': '🚕',
    '': '🚶',
    '': '🚢',
    '': '🈁',
    '': '💟',
    '': '✴',
    '': '✳',
    '': '🔞',
    '': '🚭',
    '': '🔰',
    '': '♿',
    '': '📶',
    '': '♥',
    '': '♦',
    '': '♠',
    '': '♣',
    '': '#⃣',
    '': '➿',
    '': '🆕',
    '': '🆙',
    '': '🆒',
    '': '🈶',
    '': '🈚',
    '': '🈷',
    '': '🈸',
    '': '🔴',
    '': '🔲',
    '': '🔳',
    '': '1⃣',
    '': '2⃣',
    '': '3⃣',
    '': '4⃣',
    '': '5⃣',
    '': '6⃣',
    '': '7⃣',
    '': '8⃣',
    '': '9⃣',
    '': '0⃣',
    '': '🉐',
    '': '🈹',
    '': '🈂',
    '': '🆔',
    '': '🈵',
    '': '🈳',
    '': '🈯',
    '': '🈺',
    '': '👆',
    '': '👇',
    '': '👈',
    '': '👉',
    '': '⬆',
    '': '⬇',
    '': '➡',
    '': '⬅',
    '': '↗',
    '': '↖',
    '': '↘',
    '': '↙',
    '': '▶',
    '': '◀',
    '': '⏩',
    '': '⏪',
    '': '🔯',
    '': '♈',
    '': '♉',
    '': '♊',
    '': '♋',
    '': '♌',
    '': '♍',
    '': '♎',
    '': '♏',
    '': '♐',
    '': '♑',
    '': '♒',
    '': '♓',
    '': '⛎',
    '': '🔝',
    '': '🆗',
    '': '©',
    '': '®',
    '': '📳',
    '': '📴',
    '': '⚠',
    '': '💁',
    '': '📝',
    '': '👔',
    '': '🌺',
    '': '🌷',
    '': '🌻',
    '': '💐',
    '': '🌴',
    '': '🌵',
    '': '🚾',
    '': '🎧',
    '': '🍶',
    '': '🍻',
    '': '㊗',
    '': '🚬',
    '': '💊',
    '': '🎈',
    '': '💣',
    '': '🎉',
    '': '✂',
    '': '🎀',
    '': '㊙',
    '': '💽',
    '': '📣',
    '': '👒',
    '': '👗',
    '': '👡',
    '': '👢',
    '': '💄',
    '': '💅',
    '': '💆',
    '': '💇',
    '': '💈',
    '': '👘',
    '': '👙',
    '': '👜',
    '': '🎬',
    '': '🔔',
    '': '🎶',
    '': '💓',
    '': '💗',
    '': '💘',
    '': '💙',
    '': '💚',
    '': '💛',
    '': '💜',
    '': '✨',
    '': '⭐',
    '': '💨',
    '': '💦',
    '': '⭕',
    '': '❌',
    '': '💢',
    '': '🌟',
    '': '❔',
    '': '❕',
    '': '🍵',
    '': '🍞',
    '': '🍦',
    '': '🍟',
    '': '🍡',
    '': '🍘',
    '': '🍚',
    '': '🍝',
    '': '🍜',
    '': '🍛',
    '': '🍙',
    '': '🍢',
    '': '🍣',
    '': '🍏',
    '': '🍊',
    '': '🍓',
    '': '🍉',
    '': '🍅',
    '': '🍆',
    '': '🎂',
    '': '🍱',
    '': '🍲',
    '': '😥',
    '': '😏',
    '': '😔',
    '': '😁',
    '': '😉',
    '': '😣',
    '': '😖',
    '': '😪',
    '': '😝',
    '': '😌',
    '': '😨',
    '': '😷',
    '': '😳',
    '': '😒',
    '': '😰',
    '': '😲',
    '': '😭',
    '': '😂',
    '': '😢',
    '': '☺',
    '': '😄',
    '': '😡',
    '': '😚',
    '': '😘',
    '': '👀',
    '': '👃',
    '': '👂',
    '': '👄',
    '': '🙏',
    '': '👋',
    '': '👏',
    '': '👌',
    '': '👎',
    '': '👐',
    '': '🙅',
    '': '🙆',
    '': '💑',
    '': '🙇',
    '': '🙌',
    '': '👫',
    '': '👯',
    '': '🏀',
    '': '🏈',
    '': '🎱',
    '': '🏊',
    '': '🚙',
    '': '🚚',
    '': '🚒',
    '': '🚑',
    '': '🚓',
    '': '🎢',
    '': '🚇',
    '': '🚄',
    '': '🎍',
    '': '💝',
    '': '🎎',
    '': '🎓',
    '': '🎒',
    '': '🎏',
    '': '🌂',
    '': '💒',
    '': '🌊',
    '': '🍧',
    '': '🎇',
    '': '🐚',
    '': '🎐',
    '': '🌀',
    '': '🌾',
    '': '🎃',
    '': '🎑',
    '': '🍃',
    '': '🎅',
    '': '🌅',
    '': '🌇',
    '': '🌃',
    '': '🌈',
    '': '🏩',
    '': '🎨',
    '': '🎩',
    '': '🏬',
    '': '🏯',
    '': '🏰',
    '': '🎦',
    '': '🏭',
    '': '🗼',
    '': '🇯🇵',
    '': '🇺🇸',
    '': '🇫🇷',
    '': '🇩🇪',
    '': '🇮🇹',
    '': '🇬🇧',
    '': '🇪🇸',
    '': '🇷🇺',
    '': '🇨🇳',
    '': '🇰🇷',
    '': '👱',
    '': '👲',
    '': '👳',
    '': '👴',
    '': '👵',
    '': '👶',
    '': '👷',
    '': '👸',
    '': '🗽',
    '': '💂',
    '': '💃',
    '': '🐬',
    '': '🐦',
    '': '🐠',
    '': '🐣',
    '': '🐹',
    '': '🐛',
    '': '🐘',
    '': '🐨',
    '': '🐒',
    '': '🐑',
    '': '🐺',
    '': '🐮',
    '': '🐰',
    '': '🐍',
    '': '🐔',
    '': '🐗',
    '': '🐫',
    '': '🐸',
    '': '🅰',
    '': '🅱',
    '': '🆎',
    '': '🅾',
    '': '👣',
    '': '™'
  }

  if (typeof nickName !== 'string') {
    throw new Error('wechatEmojify: nickName should be string')
  }
  if (nickName === '') return ''
  return nickName.split('').map(char => {
    return emojiMap[char] ? emojiMap[char] : char
  }).join('')
}
